module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated fadeIn"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('new_proposal_modal.new_proposal')))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('form', [_c('div', {
    staticClass: "float-label full remove-padding-right"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.document.title),
      expression: "document.title"
    }],
    attrs: {
      "type": "text",
      "name": "document-name",
      "id": "document-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.document.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "document-name"
    }
  }, [_vm._v(_vm._s(_vm.$t('new_proposal_modal.proposal_name')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('document-name')),
      expression: "errors.has('document-name')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('document-name')))])]), _vm._v(" "), (!_vm.$route.query.copy_document_id) ? _c('h3', [_vm._v(_vm._s(_vm.$t('new_proposal_modal.where_to_start')))]) : _vm._e(), _vm._v(" "), (!_vm.$route.query.copy_document_id) ? _c('div', {
    staticClass: "where-to-start"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.documentOriginOptions,
      "placeholder": _vm.$t('new_proposal_modal.template_select_dropdown.select_one'),
      "searchable": false,
      "showLabels": false
    },
    model: {
      value: (_vm.selectedDocumentOrigin),
      callback: function($$v) {
        _vm.selectedDocumentOrigin = $$v
      },
      expression: "selectedDocumentOrigin"
    }
  }), _vm._v(" "), (_vm.selectedDocumentOrigin === 'Template') ? _c('multiselect', {
    attrs: {
      "options": _vm.templates,
      "placeholder": _vm.$t('new_proposal_modal.template_select_dropdown.select_one'),
      "track-by": "id",
      "label": "title",
      "searchable": true,
      "showLabels": false,
      "maxHeight": 150
    },
    model: {
      value: (_vm.selectedTemplate),
      callback: function($$v) {
        _vm.selectedTemplate = $$v
      },
      expression: "selectedTemplate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedDocumentOrigin === 'Recent Document') ? _c('multiselect', {
    attrs: {
      "options": _vm.recentDocuments,
      "placeholder": _vm.$t('new_proposal_modal.template_select_dropdown.select_one'),
      "track-by": "id",
      "label": "title",
      "searchable": true,
      "showLabels": false,
      "maxHeight": 150
    },
    model: {
      value: (_vm.selectedDocument),
      callback: function($$v) {
        _vm.selectedDocument = $$v
      },
      expression: "selectedDocument"
    }
  }) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary is-large",
    attrs: {
      "disabled": !_vm.document.title
    },
    on: {
      "click": function($event) {
        _vm.createDocument()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('new_proposal_modal.create_proposal')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c8def8a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/new-document-modal.vue
// module id = 503
// module chunks = 0